module.exports = __webpack_public_path__ + "static/media/coffeeGif.36b24a3a.gif";